import '../theme/index.css'
import Vue from 'vue'
import Router from 'vue-router'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-default/index.css'
import App from './App.vue'
import * as filters from './filters/index.js'

window.eventHub = new Vue()

Vue.use(ElementUI)
Vue.use(Router)


// register global utility filters.
// 全局注册过滤器
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})


// 基础模块
import signUp from './modules/sign/signup.vue'	// 注册
import pwd from './modules/sign/pwd.vue'	// 注册
import matters from './modules/sign/matters.vue'	// 入驻事项
import intro from './modules/sign/intro.vue'	// 入驻介绍
import basicInfo from './modules/edit/basicInfo.vue'  // 供应商编辑入驻信息
import brandInfo from './modules/edit/brandInfo.vue'  // 供应商编辑入驻品牌信息
import finance from './modules/edit/financeInfo.vue'  // 供应商编辑入驻财务信息
import addBrand from './modules/edit/addBrand.vue'  // 图书类添加品牌信息
import notBookAddBrand from './modules/edit/notBookAddBrand.vue'  // 非图书类添加品牌信息

import supplierSkan from './modules/supplier/suppliercommonPages.vue'  // 供应商 查看
//import supplierAudit from './modules/supplier_audit/suppliercommonPages.vue'  // 供应商入驻 审核
import brandDetail from './modules/supplier/brandDetail.vue'					// 品牌详情

//已驻供应商详情
import supplierInfo from './modules/supplierInfo/suppliercommonPages.vue'  // 供应商 查看
import supplierApplyAudit from './modules/supplierapply/audit/supplierCommonPages.vue' //供应商入驻 审核
import auditBrandDetail from './modules/supplierapply/audit/brandDetail.vue'
import supplierBrandDetail from './modules/supplierInfo/brandDetail.vue'  // 供应商 查看
import supplierBrandAgreement from './modules/supplierInfo/brandAgreement.vue'  // 供应商 协议查看
import supplierBrandSupplement from './modules/supplierInfo/brandSupplement.vue'  // 供应商 补充协议查看

// 供应商编辑及审核
import supplierContactEdit from './modules/supplierInfo/manage/contactInfo.vue'  // 供应商联系人
import supplierBasicEdit from './modules/supplierInfo/manage/basicInfo.vue'     // 供应商基础信息及资质
import finance_manage from './modules/supplierInfo/manage/financeInfo.vue'

// 合同
import pact3 from './modules/edit/pact3.vue'	// 合同3

// 合同协议 编辑页面
import agreementListEdit from './modules/agreement/agreementList_edit.vue'

//合同模板 编辑
import contract_1_edit from './modules/supplier/contract/edit/contract_1.vue'
import contract_1_1_edit from './modules/supplier/contract/edit/contract_1_1.vue'
import contract_1_2_edit from './modules/supplier/contract/edit/contract_1_2.vue'
import contract_1_3_edit from './modules/supplier/contract/edit/contract_1_3.vue'
import contract_2_edit from './modules/supplier/contract/edit/contract_2.vue'
import contract_2_1_edit from './modules/supplier/contract/edit/contract_2_1.vue'
import contract_3_edit from './modules/supplier/contract/edit/contract_3.vue'
import contract_4_edit from './modules/supplier/contract/edit/contract_4.vue'
import contract_5_edit from './modules/supplier/contract/edit/contract_5.vue'
import contract_5_1_edit from './modules/supplier/contract/edit/contract_5_1.vue'
import contract_5_2_edit from './modules/supplier/contract/edit/contract_5_2.vue'
import contract_6_edit from './modules/supplier/contract/edit/contract_6.vue'
import contract_7_edit from './modules/supplier/contract/edit/contract_7.vue'
import contract_7_1_edit from './modules/supplier/contract/edit/contract_7_1.vue'
import contract_9_edit from './modules/supplier/contract/edit/contract_9.vue'
import contract_10_edit from './modules/supplier/contract/edit/contract_10.vue'
import contract_10_1_edit from './modules/supplier/contract/edit/contract_10_1.vue'
import contract_11_edit from './modules/supplier/contract/edit/contract_11.vue'
import contract_12_edit from './modules/supplier/contract/edit/contract_12.vue'
import contract_13_edit from './modules/supplier/contract/edit/contract_13.vue'
import contract_14_edit from './modules/supplier/contract/edit/contract_14.vue'
import contract_15_edit from './modules/supplier/contract/edit/contract_15.vue'
import contract_16_edit from './modules/supplier/contract/edit/contract_16.vue'
import contract_17_edit from './modules/supplier/contract/edit/contract_17.vue'
import contract_18_edit from './modules/supplier/contract/edit/contract_18.vue'
import contract_19_edit from './modules/supplier/contract/edit/contract_19.vue'

import contract_1_view from './modules/supplier/contract/view/contract_1.vue'
import contract_1_1_view from './modules/supplier/contract/view/contract_1_1.vue'
import contract_1_2_view from './modules/supplier/contract/view/contract_1_2.vue'
import contract_1_3_view from './modules/supplier/contract/view/contract_1_3.vue'
import contract_2_view from './modules/supplier/contract/view/contract_2.vue'
import contract_2_1_view from './modules/supplier/contract/view/contract_2_1.vue'
import contract_3_view from './modules/supplier/contract/view/contract_3.vue'
import contract_4_view from './modules/supplier/contract/view/contract_4.vue'
import contract_5_view from './modules/supplier/contract/view/contract_5.vue'
import contract_5_1_view from './modules/supplier/contract/view/contract_5_1.vue'
import contract_5_2_view from './modules/supplier/contract/view/contract_5_2.vue'
import contract_6_view from './modules/supplier/contract/view/contract_6.vue'
import contract_7_view from './modules/supplier/contract/view/contract_7.vue'
import contract_7_1_view from './modules/supplier/contract/view/contract_7_1.vue'
import contract_9_view from './modules/supplier/contract/view/contract_9.vue'
import contract_10_view from './modules/supplier/contract/view/contract_10.vue'
import contract_10_1_view from './modules/supplier/contract/view/contract_10_1.vue'
import contract_11_view from './modules/supplier/contract/view/contract_11.vue'
import contract_12_view from './modules/supplier/contract/view/contract_12.vue'
import contract_13_view from './modules/supplier/contract/view/contract_13.vue'
import contract_14_view from './modules/supplier/contract/view/contract_14.vue'
import contract_15_view from './modules/supplier/contract/view/contract_15.vue'
import contract_16_view from './modules/supplier/contract/view/contract_16.vue'
import contract_17_view from './modules/supplier/contract/view/contract_17.vue'
import contract_18_view from './modules/supplier/contract/view/contract_18.vue'
import contract_19_view from './modules/supplier/contract/view/contract_19.vue'

//新增合同申请
import contractEdit from './info_manage/contract/edit/agreement_edit.vue'
import contractView from './info_manage/contract/view/agreement_view.vue'

// 新增品牌品类协议页面
import categoryBrand from './info_manage/add_categary_agree/category_brand.vue'

// 新增品牌页面(已有品牌、添加新品牌)
import addBrandCommonPages from './info_manage/add_categary_agree/addBrandCommonPages.vue'

// 查看品牌品类协议页面
import skanCategoryBrand from  './info_manage/skan_agreement/skan_category_brand.vue'

// 审核 品牌
import auditBrand from './info_manage/audit_agreement/audit_brand.vue'

// 品牌品类 补充协议
import suppleBrandAgree from './info_manage/brand_supple_agree/supple_brand_agree.vue'

// 品牌品类 补充协议 查看
import suppleSkanBrand from './info_manage/brand_supple_agree/supple_skan_brand.vue'

// 品牌品类 补充协议 添加品类
import suppleAddCategory from './info_manage/brand_supple_agree/add_category.vue'

// 品牌品类 补充协议 审核页面
import suppleAuditBrand from './info_manage/brand_supple_agree/supple_audit_brand.vue'

// 品牌品类 补充协议 详情页面
import suppleBrandDetail from './info_manage/brand_supple_agree/supple_brand_detail.vue'

// 品牌品类 补充协议 详情页面
import suppleSkanCategory from './info_manage/brand_supple_agree/supple_skan_category.vue'

// 公共品牌详情
import commonDetail from './info_manage/common_detail/brand_detail.vue'

// 公共品牌对比页面
import commonCompareDetail from './info_manage/common_detail/brand_compare_detail.vue'

// 供应商基础信息编辑页面
import supplierInfoEdit from './info_manage/supplier/supplier_info_edit.vue'

// 供应商财务信息编辑页面
import supplierFinanceEdit from './info_manage/supplier/supplier_finance_edit.vue'

// 配置路径
const router = new Router({
    // mode: 'history',
    // 所有路由导航，简单地让页面滚动到顶部
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    },
    routes: [
        // 基础模块
        {path: '/sign', component: signUp},
        {path: '/pwd', component: pwd},
        {path: '/intro', component: intro},
        {path: '/matters', component: matters},
        {path: '/edit_info_basic', component: basicInfo},
        {path: '/edit_info_brand', component: brandInfo},
        {path: '/edit_info_finance', component: finance},
        {path: '/add_brand', component: addBrand},
        {path: '/notbook_addbrand', component: notBookAddBrand},
        {path: '/supplier_skan', component: supplierSkan},
        //{ path: '/supplier_audit', component: supplierAudit },
        {path: '/brandDetail', component: brandDetail},
        // { path: '/*', component: editInfo },

        {path: '/supplier_info', component: supplierInfo},
        {path: '/supplier_apply_audit', component: supplierApplyAudit},
        {path: '/auditBrandDetail', component: auditBrandDetail},
        {path: '/supplierBrandDetail', component: supplierBrandDetail},
        {path: '/supplierBrandAgreement', component: supplierBrandAgreement},
        {path: '/supplierBrandSupplement', component: supplierBrandSupplement},

        // 供应商信息编辑及审核
        {path: '/supplier_contact_manage', component: supplierContactEdit},
        {path: '/supplier_basic_manage', component: supplierBasicEdit},
        {path: '/finance_manage', component: finance_manage},

        // 合同模板 编辑
        {path: '/pact3', component: pact3},
        {path: '/contract_1_edit', component: contract_1_edit},
        {path: '/contract_1_1_edit', component: contract_1_1_edit},
        {path: '/contract_1_2_edit', component: contract_1_2_edit},
        {path: '/contract_1_3_edit', component: contract_1_3_edit},
        {path: '/contract_2_edit', component: contract_2_edit},
        {path: '/contract_2_1_edit', component: contract_2_1_edit},
        {path: '/contract_3_edit', component: contract_3_edit},
        {path: '/contract_4_edit', component: contract_4_edit},
        {path: '/contract_5_edit', component: contract_5_edit},
        {path: '/contract_5_1_edit', component: contract_5_1_edit},
        {path: '/contract_5_2_edit', component: contract_5_2_edit},
        {path: '/contract_6_edit', component: contract_6_edit},
        {path: '/contract_7_edit', component: contract_7_edit},
        {path: '/contract_7_1_edit', component: contract_7_1_edit},
        {path: '/contract_9_edit', component: contract_9_edit},
        {path: '/contract_10_edit', component: contract_10_edit},
        {path: '/contract_10_1_edit', component: contract_10_1_edit},
        {path: '/contract_11_edit', component: contract_11_edit},
        {path: '/contract_12_edit', component: contract_12_edit},
        {path: '/contract_13_edit', component: contract_13_edit},
        {path: '/contract_14_edit', component: contract_14_edit},
        {path: '/contract_15_edit', component: contract_15_edit},
        {path: '/contract_16_edit', component: contract_16_edit},
        {path: '/contract_17_edit', component: contract_17_edit},
        {path: '/contract_18_edit', component: contract_18_edit},
        {path: '/contract_19_edit', component: contract_19_edit},

        {path: '/contract_1_view', component: contract_1_view},
        {path: '/contract_1_1_view', component: contract_1_1_view},
        {path: '/contract_1_2_view', component: contract_1_2_view},
        {path: '/contract_1_3_view', component: contract_1_3_view},
        {path: '/contract_2_view', component: contract_2_view},
        {path: '/contract_2_1_view', component: contract_2_1_view},
        {path: '/contract_3_view', component: contract_3_view},
        {path: '/contract_4_view', component: contract_4_view},
        {path: '/contract_5_view', component: contract_5_view},
        {path: '/contract_5_1_view', component: contract_5_1_view},
        {path: '/contract_5_2_view', component: contract_5_2_view},
        {path: '/contract_6_view', component: contract_6_view},
        {path: '/contract_7_view', component: contract_7_view},
        {path: '/contract_7_1_view', component: contract_7_1_view},
        {path: '/contract_9_view', component: contract_9_view},
        {path: '/contract_10_view', component: contract_10_view},
        {path: '/contract_10_1_view', component: contract_10_1_view},
        {path: '/contract_11_view', component: contract_11_view},
        {path: '/contract_12_view', component: contract_12_view},
        {path: '/contract_13_view', component: contract_13_view},
        {path: '/contract_14_view', component: contract_14_view},
        {path: '/contract_15_view', component: contract_15_view},
        {path: '/contract_16_view', component: contract_16_view},
        {path: '/contract_17_view', component: contract_17_view},
        {path: '/contract_18_view', component: contract_18_view},
        {path: '/contract_19_view', component: contract_19_view},

        //新增合同申请
        {path: '/contract_edit', component: contractEdit},
        {path: '/contract_view', component: contractView},

        // 合同协议 编辑页面
        {path: '/agreement_list_edit', component: agreementListEdit},

        // 新增 品牌品类协议页面
        {path: '/category_brand', component: categoryBrand},

        // 新增 品牌页面(已有品牌、添加新品牌)
        {path: '/add_brand_commonpages', component: addBrandCommonPages},

        // 查看品牌品类协议页面
        {path: '/skan_category_brand', component: skanCategoryBrand},

        // 审核品牌
        {path: '/audit_brand', component: auditBrand},


        // 品牌品类 补充协议
        {path: '/supple_brand_agree', component: suppleBrandAgree},

        // 品牌品类 补充协议 查看页面
        {path: '/supple_skan_brand', component: suppleSkanBrand},

        // 品牌品类补充协议 添加品类
        {path: '/supple_add_category', component: suppleAddCategory},

        // 品牌品类补充协议 审核页面
        {path: '/supple_audit_brand', component: suppleAuditBrand},

        // 品牌品类补充协议 详情页面
        {path: '/supple_brand_detail', component: suppleBrandDetail},

        // 品牌品类补充协议 详情页面
        {path: '/supple_skan_category', component: suppleSkanCategory},

        // 公共品牌详情页面
        {path: '/common_detail', component: commonDetail},

        // 公共品牌对比详情页面
        {path: '/common_compare_detail', component: commonCompareDetail},

        // 供应商基础信息编辑页面
        {path: '/supplier_info_edit', component: supplierInfoEdit},

        // 供应商财务信息编辑页面
        {path: '/supplier_finance_edit', component: supplierFinanceEdit},

    ]
})

Vue.component("my-content",{
    template:"<span class='content' contenteditable='true' v-on:input='setValue($event.target)'>{{defaultValue}}</span>",
    props:["val"],
    data:function (){
        return {
            defaultValue:this.val
        };
    },
    methods:{
        setValue:function(el){
            this.$emit('input',el.innerText);
        }
    },
    watch: {
        val: function () {
            if(this.defaultValue == "" && this.$el.innerText == "" && this.val!=""){
                this.defaultValue = this.val;
            }
        }
    }
})

var vm = new Vue({
    el: '#app',
    render: h => h(App),
    router: router
});

// 时间戳 年月日时分秒
Vue.filter('datetimes', function (val) {//value为10位的时间戳

    var date = new Date(parseInt(val) * 1000);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var h = date.getHours();
    var min = date.getMinutes();
    var s = date.getSeconds();

    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;
    h = h < 10 ? '0' + h : h;
    min = min < 10 ? '0' + min : min;
    s = s < 10 ? '0' + s : s;

    return year + '-' + month + '-' + day
});



// WEBPACK FOOTER //
// ./src/main.js